import * as FC from "@fluentui/react-components";
import { idString } from "./db_utils";
import { LabelValue } from "./components/label_value";

export class TableDef {
    constructor(table, fields, prototype = null) {
        this.table = table;
        this.fields = fields;
        if (prototype) {
            this.prototype = prototype;
        }
    }

    /**
     * @param {String} key
     * @param {import("@fluentui/react-components").CreateTableColumnOptions} options
     * @returns {import("@fluentui/react-components").CreateTableColumnOptions}
     */
    createTableColumn(key, options) {
        let field = this.getField(key);

        const renderHeaderCell = () => field.label;

        const renderCell = (item) => (
            <FC.TableCellLayout>
                {field.display ? field.display(item) : item[key]}
            </FC.TableCellLayout>
        );

        return FC.createTableColumn({
            columnId: key,
            renderHeaderCell,
            renderCell,
            ...options,
        });
    }

    /**
     * @param {import("@fluentui/react-components").CreateTableColumnOptions} options
     * @returns {import("@fluentui/react-components").CreateTableColumnOptions}
     */
    createOpsColumn(options) {
        const renderHeaderCell = () => "操作";

        return FC.createTableColumn({
            columnId: "ops",
            renderHeaderCell,
            ...options,
        });
    }

    /**
     * @returns {import("@fluentui/react-components").TableRowId}
     */
    getRowId(item) {
        return idString(item.id);
    }

    label_value(item, key, labelClassName = null, valueClassName = null) {
        let field = this.getField(key);
        let value = (field.display && field.display(item)) || item[key];
        return (
            <LabelValue
                label={`${field.label}:`}
                labelClassName={labelClassName}
                value={value}
                valueClassName={valueClassName}
            />
        );
    }

    display(key) {
        let field = this.getField(key);

        return (item) => {
            if (field.display) {
                return field.display(item);
            } else {
                return item[key];
            }
        };
    }

    getField(key) {
        let field = this.fields[key];
        if (!field) {
            throw `table ${this.table} has not field: ${key}`;
        }
        return field;
    }
}
